// extracted by mini-css-extract-plugin
export default {"select":"SelectCategoryGroups_select__gu3vI"};